import { Translation } from "../i18n-types";

const hu: Translation = {
    "state-is-required": "A megye kötelező adat.",
    description: {
        "show-more": "Mutass többet",
        "show-less": "Mutass kevesebbet"
    },
    footer: {
        "why-shop-with-us": "Az Önök szavai szerint miért érdemes nálunk vásárolni?",
        "heureka-image-url": "/footer/img/hu/comparator.png",
        benefits: {
            first: "Szuper gyors kiszállítás.",
            second: "Extra gyors és megbízható szolgáltatás.",
            third: "Barátságos ügyfélszolgálati megközelítés."
        },
        social: {
            "facebook-plugin-url":
                "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ffoxigy.hu&tabs&width=314&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
            "facebook-page-url": "https://www.facebook.com/foxigy.hu",
            "instagram-page-url": "https://www.instagram.com/foxigy.hu/",
            "youtube-page-url": "https://www.youtube.com/channel/UCGes5fyH2m_7ysNOgydXvNw"
        },
        "your-foxigy-image-link": "/footer/img/hu/your-foxigy.png"
    }
};

export default hu;
